import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LOADING_STATE } from "types/general";
import { DEMOGRAPHICS_SLICE_NAME, initialState } from "./constants";
import { fetchDemographics } from "./controllers";
import { DemographicsAreaTypeEnum } from "./types";

const demographicsSlice = createSlice({
  name: DEMOGRAPHICS_SLICE_NAME,
  initialState,
  reducers: {
    resetDemographics: () => initialState,
    setSelectedBenchmarkAreaType: (
      state,
      { payload }: PayloadAction<DemographicsAreaTypeEnum | undefined>
    ) => {
      state.selectedBenchmarkAreaType = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDemographics.pending, (state) => {
        state.loadingState = LOADING_STATE.pending;
      })
      .addCase(fetchDemographics.rejected, (state) => {
        state.loadingState = LOADING_STATE.rejected;
      })
      .addCase(fetchDemographics.fulfilled, (state, { payload }) => {
        state.data = payload;
        state.loadingState = LOADING_STATE.fulfilled;
      });
  },
});

export const { resetDemographics, setSelectedBenchmarkAreaType } =
  demographicsSlice.actions;

export default demographicsSlice;
